export const colors = {
  primaryColor    : "#56ac34",
  secondaryColor :"#45ac34",
  // NAV BAR
  navbar_bg:"#F9F9FA",
  navbar_font:'#000000',
  navbar_profile_bg :'#EEE9DA',
  navbar_profile_icon :'#000000',
  nav_bar_menu_icon : "#000000",



  // SIDE MENU
  sideBar_bg:'#CCB98B',
  sideBar_item_bg:"#982345",

  sideBar_font:'#000000',

  sideBar_item_bg_hover:"#982345",
  sideBar_font_hover:'#FFFFFF',

  sideBar_item_bg_active:"#5BAF3B",
  sideBar_font_active:'#652312',

  // BUTTON
  save_buttom_bg:'#D85668',
  save_buttom_font:'#FFFFFF',
  save_buttom_border:'#D85668',


  cancel_button_bg:'#EEEEEE',
  cancel_button_font:'#000000',
  cancel_button_border:'#EEEEEE',

  add_button_bg:'#FFFFFF',
  add_button_font:'#7FC068',
  add_button_border:'#7FC068',

// TABLE
  table_head_bg : "#CEDFF3",
  table_head_font : "#FFFFFF",

}